import src from "IMAGE";
export default { src, width: 215, height: 192, blurWidth: 0, blurHeight: 0};
